module.exports = __webpack_public_path__ + "img/content5_840_15.3c82a79e.png";